import type { Attendee, Profile } from '@tunasong/schemas'

export const toAttendee = ({ userId, name, email }: Pick<Profile, 'userId' | 'name' | 'email'>): Attendee => ({
  userId,
  name: name ?? email,
  email,
  optional: false,
})
